import { render, staticRenderFns } from "./PresellDetails.vue?vue&type=template&id=41250858&scoped=true"
import script from "./PresellDetails.vue?vue&type=script&lang=js"
export * from "./PresellDetails.vue?vue&type=script&lang=js"
import style0 from "./PresellDetails.vue?vue&type=style&index=0&id=41250858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41250858",
  null
  
)

export default component.exports